import { render, staticRenderFns } from "./ScheduleEditForm.vue?vue&type=template&id=228972e6&scoped=true&"
import script from "./ScheduleEditForm.vue?vue&type=script&lang=js&"
export * from "./ScheduleEditForm.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleEditForm.vue?vue&type=style&index=0&id=228972e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228972e6",
  null
  
)

export default component.exports